import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ChartViewDTO } from '../../model/chart_view/chart-view-dto';
import { QuantiteDossierPrecontentieuxDTO } from '../../model/QuantiteDossierPrecontentieuxDTO';
import { QuantiteDossierImpayeDTO } from '../../model/QuantiteDossierImpayeDTO';
import { PageDossierDTO } from 'src/app/suivi-portefeuille/core/model/page-DossierDTO';

@Injectable({
  providedIn: "root"
})
export class DashboardImpayeServiceService {
  constructor(private _restClientService: RestClientService) {}

  nombreCumulativeDossier() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-impaye/evolution-dossier-impaye-Sur-periode"
    );
  }

  nombreDossierContentieux() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-impaye/nombre-dossier-contentieux-filtrer-Sur-periode"
    );
  }


  nombreDossierContentieuxProvions() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-impaye/nombre-dossier-contentieux-provision-filtrer-Sur-periode"
    );
  }

  quantiteDossierContentieux() {
    return this._restClientService.load<ChartViewDTO>(
      "dashboard-impaye/quantite-dossier-contentieux-surLes6DerniersMois"
    );
  }



  listDossierEnRecouvrement() {
    return this._restClientService.load<QuantiteDossierImpayeDTO[]>(
      "dashboard-impaye/dossier-en-recouvrement"
    );
  }


  pourcentageDossierImpayeTypeMarche(typeMarche) {
    return this._restClientService.load<any[]>(
      "dashboard-impaye/pourcentage-dossier-impaye-By-typeMarche?typeMarche=" +
        typeMarche
    );
  }


  findAllPagingDossierImpayen(filter, page, size, sortColumn, descending) {
    return this._restClientService.load<PageDossierDTO>(
      "dashboard-impaye/dossier-pageable-impaye" +
        "?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size +
        "&sortColumn=" +
        sortColumn +
        "&descending=" +
        descending
    );
  }

}
